import { render, staticRenderFns } from "./UserRequestHandler.vue?vue&type=template&id=d67459ec&scoped=true&"
import script from "./UserRequestHandler.vue?vue&type=script&lang=js&"
export * from "./UserRequestHandler.vue?vue&type=script&lang=js&"
import style0 from "./UserRequestHandler.vue?vue&type=style&index=0&id=d67459ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67459ec",
  null
  
)

export default component.exports